import React, { useContext, useEffect, useState } from "react";
import Account from "../../Services/accountServices";
import { Input, Select, message } from "antd";
import { Calendar } from "primereact/calendar";
import Loader from "../../Components/Loader";
import { AuthContext } from "../../Auth/Context/AuthContext";
import { useNavigate } from "react-router-dom";
import TitleHeader from "./Components/TitleHeader";
import { SETTINGS } from "../../config/settings";
import { SelectField } from "../../Components/InputFormFields";
function JournelEntry(props) {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [lines, setLines] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [isAfnAccount, setIsAfnAccount] = useState(false);
  const [exchangeRate, setExchangeRate] = useState();
  const [date, setDate] = useState(new Date().toISOString());
  const [attachment, setAttachmentName] = useState();
  const initialRows = [
    { id: 1, debit: "", credit: "", accountId: [], memo: "" },
    { id: 2, debit: "", credit: "", accountId: [], memo: "" },
    { id: 3, debit: "", credit: "", accountId: [], memo: "" },
    { id: 4, debit: "", credit: "", accountId: [], memo: "" },
  ];
  const [rowData, setRowData] = useState(initialRows);
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  const addRow = () => {
    const newRow = {
      id: rowData.length + 1,
      debit: "",
      credit: "",
      account: "",
      memo: "",
    };
    setRowData([...rowData, newRow]);
  };

  const handleNumberChange = (id, field, value) => {
    const updatedData = rowData.map((row, index) => {
      if (row.id === id) {
        // return { ...row, [field]: parseInt(value) };
        return { ...row, [field]: value };
      }
      // Auto-fill the memo attribute of the next row if the current row is filled
      else {
        const nextRow = rowData[index + 1];
        if (index === id) {
          if (field === "debit")
            return { ...row, ...(nextRow && { credit: value }) };
          if (field === "credit")
            return { ...row, ...(nextRow && { debit: value }) };
        }
      }
      //end next row
      return row;
    });
    setRowData(updatedData);
  };
  const handleSelectChange = (id, value) => {
    const updatedData = rowData.map((row, index) => {
      if (row.id === id) {
        //changed for searchable select
        return { ...row, accountId: value.value };
      }
      return row;
    });
    const isAFNExists = updatedData.filter(
      (op) =>
        accounts.find((o) => o.id === op.accountId)?.currencyName === "AFN"
    );
    if (isAFNExists.length > 0) setIsAfnAccount(true);
    else setIsAfnAccount(false);
    setRowData(updatedData);
  };

  const handleTextChange = (id, value) => {
    const updatedData = rowData.map((row, index) => {
      if (row.id === id) {
        return { ...row, memo: value };
      }
      // Auto-fill the memo attribute of the next row if the current row is filled
      else {
        const nextRow = rowData[index + 1];
        if (index === id) return { ...row, ...(nextRow && { memo: value }) };
      }
      //end Next row
      return row;
    });
    setRowData(updatedData);
  };

  const handleFormSubmit = async (action) => {
    setLoading(true);
    let totalCredit = 0;
    let totalDebit = 0;

    const lineItems = rowData.filter(
      (op) => (op.accountId && op.credit) || (op.accountId && op.debit)
    );
    const lines = lineItems.map((item) => {
      const { id, ...rest } = item;
      return rest;
    });
    //see if account is selected for every row
    for (let i = 0; i < lines.length; i++) {
      if (!lines[i].debit) lines[i].debit = null;
      if (!lines[i].credit) lines[i].credit = null;
      if (lines[i].credit) totalCredit += parseInt(lines[i].credit);
      if (lines[i].debit) totalDebit += parseInt(lines[i].debit);
      if (!lines[i].accountId) {
        setLoading(false);
        return message.error("Please Select Account");
      }
    }
    const filteredAccounts = accounts.filter((account) => {
      return (
        account.currencyName === "AFN" &&
        lines.some((item) => item.accountId === account.id)
      );
    });
    if (filteredAccounts.length > 0) setIsAfnAccount(true);

    // both side must be balanced and if AFN account exists then exchange rate is must
    if (totalCredit === totalDebit && totalCredit !== 0 && totalDebit !== 0) {
      if (isAfnAccount && !exchangeRate) {
        setLoading(false);
        return message.error("Exchange Rate must be provided for AFN accounts");
      }
      const data = {
        currencyRate: parseInt(exchangeRate) || null,
        transactionType: "GENERAL_JOURNAL",
        date,
        lines,
        branchId: user.branchId,
        attachment: attachment ? await toBase64(attachment) : null,
      };
      await Account.addJournelEntry(data)
        .then((response) => {
          message.success("Entry Saved");
          setLines([]);
          setLoading(false);
          if (action === "close") navigate("/genral-journel");
          else window.location.reload();
        })
        .catch((error) => {
          setLoading(false);
          message.error("Network Error");
          console.log("Network Error", error);
        });
    } else {
      setLoading(false);
      message.error("Transaction is not Balanced");
    }
  };

  const fetchAccounts = async () => {
    await Account.getAllAccounts().then((acc) => {
      setAccounts(acc.data);
    });
  };

  const resetForm = () => {
    setRowData(initialRows);
    const updatedRowData = initialRows.map((row) => ({
      ...row,
      accountId: "",
    }));
    setRowData(updatedRowData);
  };
  useEffect(() => {
    fetchAccounts();
  }, []);
  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"></div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <TitleHeader title="General Journal - New Entry" />
          <div class="card">
            <div class="card-body">
              <div class="row">
                <>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <strong>Date: </strong>
                      {`${new Date(date).getFullYear()}/${
                        new Date(date).getMonth() + 1
                      }/${new Date(date).getDate()}`}
                      <br />
                      <Calendar
                        name="date"
                        onChange={(e) => setDate(e.value.toISOString())}
                        showIcon
                        placeholder="Date"
                      />
                    </div>

                    <div>
                      <strong>Exchange Rate</strong>
                      <Input
                        disabled={!isAfnAccount}
                        className="form-group"
                        type="number"
                        placeholder="Exchange Rate"
                        name="exchangeRate"
                        onChange={(e) => setExchangeRate(e.target.value)}
                      />
                    </div>
                    <div>
                      <strong>Receipt</strong>
                      <Input
                        type="file"
                        name="attachment"
                        onChange={(e) => setAttachmentName(e.target.files[0])}
                      />
                    </div>
                  </div>
                  <table className="table-sm">
                    <thead>
                      <th>
                        <strong>Account</strong>
                      </th>
                      <th>
                        <strong>Memo</strong>
                      </th>
                      <th>
                        <strong>
                          Debit{" "}
                          <span style={{ color: "green" }}>
                            (
                            {isAfnAccount
                              ? SETTINGS.currencies.afn
                              : SETTINGS.currencies.usd}
                            )
                          </span>
                        </strong>
                      </th>
                      <th>
                        <strong>
                          Credit{" "}
                          <span style={{ color: "green" }}>
                            (
                            {isAfnAccount
                              ? SETTINGS.currencies.afn
                              : SETTINGS.currencies.usd}
                            )
                          </span>
                        </strong>
                      </th>
                    </thead>
                    {rowData.map((row) => (
                      <tr key={row.id}>
                        <td className="form-group" style={{ width: "25%" }}>
                          {/* <Select
                            style={{ width: 200, height: 48 }}
                            placeholder="Select Account"
                            type="select"
                            name="account"
                            onChange={(e) => handleSelectChange(row.id, e)}
                          >
                            <option value="">Select</option>
                            {accounts &&
                              accounts.map((type) => (
                                <option value={type.id}>{type.name}</option>
                              ))}
                          </Select> */}
                          <SelectField
                            name="account"
                            options={accounts.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))}
                            onChange={(e) => handleSelectChange(row.id, e)}
                            searchable={true}
                          />
                        </td>
                        <td className="form-group w-50">
                          <Input
                            style={{ height: 50 }}
                            type="text"
                            value={row.memo}
                            onChange={(e) =>
                              handleTextChange(row.id, e.target.value)
                            }
                          />
                        </td>
                        <td className="form-group w-20">
                          <Input
                            style={{ height: 50 }}
                            className="form-group"
                            type="number"
                            value={row.debit}
                            onChange={(e) =>
                              handleNumberChange(
                                row.id,
                                "debit",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td className="form-group w-20">
                          <Input
                            style={{ height: 50 }}
                            className="form-group"
                            type="number"
                            value={row.credit}
                            onChange={(e) =>
                              handleNumberChange(
                                row.id,
                                "credit",
                                e.target.value
                              )
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </table>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <button
                        href="#"
                        class="btn btn-cancel"
                        onClick={() => handleFormSubmit("new")}
                      >
                        <i className="ion-upload"></i> Save and New
                      </button>
                      &nbsp;
                      <button
                        href="#"
                        class="btn btn-cancel"
                        onClick={() => handleFormSubmit("close")}
                      >
                        <i className="ion-upload"></i> Save and Close
                      </button>
                    </div>
                    <div>
                      <button className="btn btn-cancel" onClick={resetForm}>
                        <i className="ion-loop"></i> Clear
                      </button>
                      &nbsp;
                      <button className="btn btn-primary" onClick={addRow}>
                        <i className="ion-plus"></i> Row
                      </button>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default JournelEntry;
